export const SampleLine = ({ item }) => {
  return (
    <tr className='text-center'>
      <td>{item.productName}</td>
      <td>{item.quantity}</td>
      <td>{item.size ? item.size : 'N/A'}</td>
    </tr>
  )
}
